<template>
  <v-dialog
    :value="visiblePopup"
    @keydown.esc="onYesClickButton"
    @click:outside='onYesClickButton'
    :max-width="830"
  >
    <v-card class="popup-wrapper">
      <div class='popup-wrapper__action'>
        <span class='close_btn' @click='onYesClickButton'>
          <span class="material-icons-outlined">
            close
          </span>
        </span>
      </div>
      <div class="title">{{$t(title)}}</div>
      <!-- issued to -->
      <div class='data-title'>{{$t('host.certificate.popup.issued.to')}}</div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.common.name')}}</div>
        <div class='data-text'>{{data.CommonNameSubject}}</div>
      </div>
      <!-- issued by -->
      <div class='data-title extra-space'>{{$t('host.certificate.popup.issued.by')}}</div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.common.name')}}</div>
        <div class='data-text'>{{data.CommonNameIssuer}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.organization.name.issuer')}}</div>
        <div class='data-text'>{{data.OrganizationNameIssuer}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.organization.unit')}}</div>
        <div class='data-text'>{{data.OrganizationUnit}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.country.issuer')}}</div>
        <div class='data-text'>{{data.CountryIssuer}}</div>
      </div>
      <!-- validity -->
      <div class='data-title extra-space'>{{$t('host.certificate.popup.validity.period')}}</div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.issued.date')}}</div>
        <div class='data-text'>{{dateFormatted(data.IssuedDate)}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.expires.date')}}</div>
        <div class='data-text'>{{dateFormatted(data.ExpiresDate)}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.days.left')}}</div>
        <div class='data-text'>{{data.DaysLeft}}</div>
      </div>
      <!-- certificate -->
      <div class='data-title extra-space'>{{$t('host.certificate.popup.sha256.fingerprint')}}</div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.serial.number')}}</div>
        <div class='data-text'>{{data.SerialNumber}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.ssl.version')}}</div>
        <div class='data-text'>{{data.SSLVersion}}</div>
      </div>
      <!-- fingerprint -->
      <div class='data-title extra-space'>{{$t('host.certificate.popup.fingerprint')}} SHA-256</div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.sha256.fingerprint')}}</div>
        <div class='data-text'>{{data.SHA256Fingerprint}}</div>
      </div>
      <div class='data-row'>
        <div class='data-subtitle'>{{$t('host.certificate.popup.public.key.sha256.fingerprint')}}</div>
        <div class='data-text'>{{data.PublicKeySHA256Fingerprint}}</div>
      </div>
      <!-- data end -->
      <div class="buttons">
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()">
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'CertificatePopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    data: {
      required: false,
      type: Object,
      default: () => {},
    },
    yesCaption: String,
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', true);
    },
    async copyAsset(asset, type) {
      const data = asset;
      await navigator.clipboard.writeText(data);
      this.displayedCopiedBadge[type] = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.displayedCopiedBadge[type] = false;
    },
    dateFormatted(dateString) {
      try {
        const date = new Date(`${dateString.replace(' ', 'T')}Z`);
        const weekday = date.toLocaleString('en-US', { weekday: 'long' });
        const month = date.toLocaleString('en-US', { month: 'long' });
        const day = date.getDate();
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours %= 12;
        hours = hours || 12;
        return `${weekday}, ${month} ${day}, ${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
      } catch (e) {
        return dateString;
      }
    },
  },
  data() {
    return {
      displayedCopiedBadge: {
        asn: false,
        ip: false,
        network: false,
      },
    };
  },
  computed: {
    getFormattedExtension() {
      return '';
    },
    badgeIcon() {
      return 'build';
    },
    badgeContent() {
      return this.$t('copied');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(830);
  padding: $space-8 $space-10;
  background-color: var(--bg-primary);
  &__action {
    .close_btn {
      margin-right: rem(-20);
      margin-top: rem(-12);
      float: right;
      &:hover {
        cursor: pointer;
        color: var(--brand-primary);
      }
    }
  }
  .title {
    color: var(--text-primary);
    font-size: $font-size-xl;
    font-weight: 600;
    letter-spacing: 1.12px;
    line-height: rem(24);
    text-transform: uppercase;
    padding-bottom: rem(23);
  }
  .data-title {
    display: flex;
    color: var(--text-primary);
    font-size: $font-size-sm;
    font-family: $font-family-semibold;
    letter-spacing: 0.8px;
    line-height: $font-size-xs;
    text-transform: uppercase;
    margin-bottom: rem(10);
    margin-top: rem(10);
  }
  .extra-space{
    margin-top: rem(10);
  }
  .data-row {
    display: flex;
    flex-direction: row;
    min-width: rem(600);
    max-width: rem(600);
    justify-content: space-between;
    .data-subtitle{
      color: var(--text-secondary);
      font-size: rem(13);
      margin-right: $space-1-5;
      min-width: rem(195);
    }
    .data-text{
      display: flex;
      justify-content: left;
      min-width: rem(400);
    }
  }
  .manual-config-badge {
    max-width: fit-content;
    line-height: 1.5;
    &:hover {
      cursor: pointer;
    }
    .copied {
      text-transform: capitalize;
      color: var(--brand-primary);
    }
  }
  .buttons {
    text-align: right;
    padding-top: rem(30);
    .yes-button {
      height: $space-8;
      width: rem(51);
      border-radius: $radius-sm;
      background-color: var(--brand-primary) !important;
      box-shadow: $shadow-sm;
      color: var(--text-inverse) !important;
      font-size: $font-size-sm;
      font-weight: 500;
      letter-spacing: 1.07px;
      line-height: $space-4;
      text-align: center;
      margin-left: $space-2;
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.popup-wrapper {
  .manual-config-badge {
    .v-badge__wrapper {
      .v-badge__badge.v-badge__badge {
        background: transparent;
        border: none;
        color: var(--brand-primary);
        .v-icon {
          font-size: $space-4;
          transform: rotate(180deg);
        }
      }
    }
    &.copied-badge {
      .v-badge__wrapper {
        .v-badge__badge.v-badge__badge {
          text-transform: capitalize;
          background: transparent;
          border: none;
          color: var(--brand-primary);
          right: $space-5;
          inset: auto auto calc(100% - 1px) calc(100% - #{rem(30)});
        }
      }
    }
  }
}
</style>
